import { getCatalogDetailExternalUrl } from '@/redux/modules/catalog/detail/catalogDetail.selectors';
import { getCatalogPaymentProvider } from '@/redux/modules/catalog/catalogs/catalog.selectors';
import { getDefaultBidderCreditCardId } from '@/redux/modules/account/payments/creditCard/creditCard/creditCard.selectors';
import { getItemDetailExternalUrl } from '@/redux/modules/itemDetail';
import { submitRegisterForCatalog } from '@/redux/modules/registerForCatalog';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { useCallback } from 'react';
import { useRequireLogin } from '@/components/ShouldLogIn/hooks/useRequireLogin';

type Props = {
    catalogId: number;
    itemId: number;
};

export const useViewOrRegisterOnPartnerSite = ({ catalogId, itemId }: Props) => {
    const verifyLogin = useRequireLogin();
    const dispatch = useAppDispatch();
    const paymentProvider = useAppSelector((state) => getCatalogPaymentProvider(state, catalogId));
    const cardId = useAppSelector((state) => getDefaultBidderCreditCardId(state, paymentProvider));

    const catalogExternalUrl = useAppSelector((state) => getCatalogDetailExternalUrl(state, catalogId));
    const itemExternalUrl = useAppSelector((state) => getItemDetailExternalUrl(state, itemId));
    const externalUrl = itemId ? itemExternalUrl : catalogExternalUrl;

    return useCallback(
        async (reason: 'view' | 'register') => {
            if (reason === 'register') {
                await verifyLogin({
                    requireLogin: true,
                    runFunction: () =>
                        dispatch(
                            submitRegisterForCatalog({
                                cardId,
                                catalogId,
                                itemId,
                            })
                        ),
                });
            }

            if (Boolean(externalUrl)) {
                window.open(externalUrl, '_blank');
            }
        },
        [cardId, catalogId, dispatch, externalUrl, itemId, verifyLogin]
    );
};
